module.exports = __webpack_public_path__ + "static/media/jialishan.0790ba72.webp";